var map = {
	"./banknote-with-dollar-sign.png": 63067,
	"./bar-chart.png": 46550,
	"./bust-in-silhouette.png": 34473,
	"./classical-building.png": 20268,
	"./confused.png": 54623,
	"./custom-distribution.png": 19892,
	"./dollar-sign.png": 57634,
	"./ear-of-rice.png": 61355,
	"./fountain-pen.png": 34345,
	"./happy.png": 85192,
	"./incoming-envelope.png": 37499,
	"./investment-details.png": 89296,
	"./memo.png": 96671,
	"./money-bag.png": 51690,
	"./money-with-wings.png": 5779,
	"./no-entry.png": 84551,
	"./page-facing-up.png": 46961,
	"./party-popper.png": 27904,
	"./waving-hand-sign.png": 61882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3778;